import {Pipe} from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormat {
  transform(n: number, dec: number) : string {
    return n.toFixed(dec);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/number-format.pipe.ts